import type { UseDisclosureWithContextReturn } from '@talos/kyoko';
import { useFeatureFlag } from '../../../../hooks';
import { ModifyFixingDialogV1 } from './ModifyFixingDialogV1';
import { ModifyFixingDialogV2, type ModifyFixingV2Props } from './V2/ModifyFixingDialogV2';

/** A wrapper for the V1 and V2 versions of the fixing dialog. Based on the feature flag, will render the correct one for you */
export const ModifyFixingDialog = (props: UseDisclosureWithContextReturn<ModifyFixingV2Props>) => {
  const { enableModifyFixingDialogV2 } = useFeatureFlag();

  if (enableModifyFixingDialogV2) {
    return <ModifyFixingDialogV2 {...props} />;
  }

  return <ModifyFixingDialogV1 {...props} />;
};

export type ModifyFixingProps = ModifyFixingV2Props;
